import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaList, FaTruck, FaHeart } from 'react-icons/fa';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { IoIosHome } from "react-icons/io";
import { FaBorderAll } from "react-icons/fa6";
import { IoMdLogOut } from "react-icons/io";
import { RiLockPasswordLine } from "react-icons/ri";
import { useDispatch } from 'react-redux';
import { customer_logout, user_reset } from '../store/reducers/authReducer'
import { reset_count } from '../store/reducers/cardReducer'


const Dashboard = () => {
    const [filterShow, setFilterShow] =  useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const logout = async () => {
        await dispatch(customer_logout())
        dispatch(user_reset())
        dispatch(reset_count())
        navigate('/login')
    }

    return (
        <div>
           <Header/>
           <div className='bg-slate-200 mt-5'>
                <div className='w-[90%] mx-auto md-lg:block hidden'>
                    <div>
                        <button onClick={() => setFilterShow(!filterShow)} className='text-center py-3 px-3 bg-green-500 text-white'><FaList/> </button>
                    </div> 
                </div>

        <div className='h-full mx-auto'>
            <div className='py-5 flex md-lg:w-[90%] mx-auto relative'>
                <div className={`rounded-md z-50 md-lg:absolute ${filterShow ? '-left-4' : '-left-[360px]'} w-[270px] ml-4 bg-white`}>

            <ul className='py-2 text-slate-600 px-4'> 
                
                <li className='flex justify-start items-center gap-2 py-2'>
            <span className='text-xl'><IoIosHome /></span>
            <Link to='/dashboard' onClick={() => setFilterShow(false)} className='block' >Dashboard </Link>
                </li>
                <li className='flex justify-start items-center gap-2 py-2'>
            <span className='text-xl'><FaBorderAll/></span>
            <Link to='/dashboard/my-orders' onClick={() => setFilterShow(false)} className='block' >My Orders </Link>
                </li>
                <li className='flex justify-start items-center gap-2 py-2'>
            <span className='text-xl'><FaHeart/></span>
            <Link to='/dashboard/my-wishlist' onClick={() => setFilterShow(false)} className='block' >Wishlist </Link>
                </li>
                <li className='flex justify-start items-center gap-2 py-2'>
            <span className='text-xl'><FaTruck/></span>
            <Link to='/dashboard/delivery' onClick={() => setFilterShow(false)} className='block' >Delivery </Link>
                </li>
                <li className='flex justify-start items-center gap-2 py-2'>
            <span className='text-xl'><RiLockPasswordLine/></span>
            <Link to='/dashboard/change-password' onClick={() => setFilterShow(false)} className='block' >Change Password  </Link>
                </li>
                <li onClick={logout} className='flex justify-start items-center gap-2 py-2 cursor-pointer'>
            <span className='text-xl'><IoMdLogOut/></span>
            <div  className='block' >Logout </div>
                </li> 

            </ul> 
                </div>


                <div className='w-[calc(100%-270px)] md-lg:w-full'>
                    <div className='mx-4 md-lg:mx-0'>
                        <Outlet/>
                    </div>
                </div>
                
            </div>
        </div>        






           </div>

           <Footer/>
        </div>
    );
};

export default Dashboard;